export default __webpack_public_path__ + "static/media/core.c9f045de.svg";